/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { ListPlayerActivity200ResponseResultInner } from './ListPlayerActivity200ResponseResultInner';
import {
    ListPlayerActivity200ResponseResultInnerFromJSON,
    ListPlayerActivity200ResponseResultInnerFromJSONTyped,
    ListPlayerActivity200ResponseResultInnerToJSON,
    instanceOfListPlayerActivity200ResponseResultInner,
} from './ListPlayerActivity200ResponseResultInner';

/**
 * 
 * @export
 * @interface ListPlayerActivity200Response
 */
export interface ListPlayerActivity200Response {
    /**
     * 
     * @type {Array<ListPlayerActivity200ResponseResultInner>}
     * @memberof ListPlayerActivity200Response
     */
    result?: Array<ListPlayerActivity200ResponseResultInner>;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200Response
     */
    total?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPlayerActivity200Response
     */
    offset?: string;
}


/**
 * Check if a given object implements the ListPlayerActivity200Response interface.
 */
export function instanceOfListPlayerActivity200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function ListPlayerActivity200ResponseFromJSON(json: any): ListPlayerActivity200Response {
    return ListPlayerActivity200ResponseFromJSONTyped(json, false);
}

export function ListPlayerActivity200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPlayerActivity200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'result': !exists(json, 'result') ? undefined : ((json['result'] as Array<any>).map(ListPlayerActivity200ResponseResultInnerFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
    };
}

export function ListPlayerActivity200ResponseToJSON(value?: ListPlayerActivity200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'result': value.result === undefined ? undefined : ((value.result as Array<any>).map(ListPlayerActivity200ResponseResultInnerToJSON)),
        'total': value.total,
        'offset': value.offset,
    };
}

